import React, { useState } from "react";
import styles from "../Nav/Nav.module.css";
import whatsapp_icon from "../../images/whatsapp2_icon.png";
import whatsapp_icon2 from "../../images/whatsapp_icon.png";
import tel_img from "../../images/telphone.png";
import { IoIosArrowDropdown } from "react-icons/io";
import hamburger_menu from "../../images/hamburger.png";
import logo from "../../images/logo2.png";
import { useNavigate } from "react-router-dom";

const Nav = () => {
  // for togglNavbar
  const [sidebar, setSidebar] = useState(false);
  const toggleSidebar = () => {
    setSidebar(!sidebar);
  };

  const closeSidebar = () => {
    setSidebar(false);
  };

  let navigate = useNavigate();
  const goToHome = () => {
    navigate("/");
    setSidebar(false);
  };
  const NavData = [
    "APPLIANCES CARE",
    "HOME CARE",
    "GADGET CARE",
    "HANDYMAN",
    "BEAUTY CARE  ",
    "FITNESS CARE",
    " BUSINESS CARE",
    "ALL SERVICES",
    "BLOG",
  ];
  return (
    <>
      <div className={styles.container}>
        <div className={styles.navLinks}>
          {NavData.map((elem, ind) => {
            return (
              <>
                <a onClick={() => goToHome()}>
                  {elem} {<IoIosArrowDropdown />}
                </a>
              </>
            );
          })}
        </div>
        <div className={styles.navImages}>
          <h4>
            <img src={tel_img} alt="tel_img" />
            SERVICE HELPLINE <br />
            <a href="tel:7827621417">7827621417</a>
          </h4>
          <img src={whatsapp_icon} alt="whatsapp_img" />
        </div>
      </div>
      {/* this container for only mobile devices... */}
      <div className={styles.container_2}>
        <div className={styles.hamburger_menu} onClick={() => toggleSidebar()}>
          <img src={hamburger_menu} alt="hamburger_menu" />
        </div>
        <div className={styles.logos} onClick={() => goToHome()}>
          <img src={logo} alt="logo" />
          <h5>
            RO <br /> SERVICE <br /> CENTER
          </h5>
        </div>
        <div className={styles.whatsapp_icons}>
          <img src={whatsapp_icon} alt="whatsapp_icon" />
          <img src={whatsapp_icon} alt="whatsapp_icon" />
        </div>
      </div>

      {sidebar == true ? (
        <>
          <div className={styles.smallNavLinks}>
            {NavData.map((elem, ind) => {
              return (
                <>
                  <a onClick={() => goToHome()}>
                    {elem} {<IoIosArrowDropdown />}
                  </a>
                </>
              );
            })}
            <p className={styles.close_me} onClick={() => setSidebar(false)}>
              close
            </p>
          </div>
        </>
      ) : (
        ""
      )}
    </>
  );
};

export default Nav;
